<script>
import { defineComponent } from 'vue';
import { t } from '@nova/core';
import { isFunction } from 'lodash';

import YardTasksCreateMoveTaskForm from './YardTasksCreateMoveTaskForm.vue';
import { useCreateYardTaskDrawer } from '../composables/useCreateYardTaskDrawer';

export default defineComponent({
  name: 'EventTriggeredCreateMoveTaskDrawer',
  components: {
    YardTasksCreateMoveTaskForm
  },
  setup() {
    const {
      tab,
      isDialogOpen,
      dialogProps,
      currentTaskData,
      isSubmitDisabled,

      closeDialog,
      getDialogProp,
      createTask,
      handleValidate
    } = useCreateYardTaskDrawer({
      dialogEventName: 'open-create-yard-move-task-drawer',
      defaultTaskType: 'move'
    });

    const skipAndConfirmMove = async () => {
      if (!dialogProps.value) {
        console.error('Failed to skip and confirm move: No dialog props found');
        return;
      }

      const onSkipCreateTask = getDialogProp('onSkipCreateTask');

      try {
        if (isFunction(onSkipCreateTask)) {
          onSkipCreateTask();
        }
        closeDialog();
      } catch (error) {
        console.error('Failed to skip and confirm move:', error);
      }
    };

    return {
      t,
      tab,
      isDialogOpen,
      isSubmitDisabled,
      closeDialog,
      createTask,
      skipAndConfirmMove,
      currentTaskData,
      handleValidate,
      dialogProps
    };
  }
});
</script>

<template>
  <v-dialog
    v-model="isDialogOpen"
    @keydown.escape="closeDialog"
    transition="slide-left"
    content-class="drawer-like"
    v-bind="$attrs">
    <v-card class="dialog-box" data-testid="create-task-dialog">
      <v-card-title class="d-flex flex-row align-center">
        <h2 class="typography-heading-lg">
          {{ t('yard.drawers.createTaskDrawer.headers.createMoveTask') }}
        </h2>
        <v-spacer></v-spacer>
        <v-btn variant="text" icon="mdi-close" @click="closeDialog" />
      </v-card-title>

      <v-card-text class="dialog-body d-flex flex-column gap-4">
        <p
          class="typography-body-sm"
          v-html="
            t(
              'yard.drawers.createTaskDrawer.messages.moveTasksLetYardDriversRecordAMoveInRealTimeFromTheirAppOnceCompletedTheMovementIsInstantlyUpdatedInTheYardView'
            )
          "></p>

        <yard-tasks-create-move-task-form
          v-if="tab === 'move'"
          v-model="currentTaskData"
          @validate="handleValidate" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="dialog-actions">
        <v-btn
          variant="text"
          @click="skipAndConfirmMove"
          data-testid="create-move-task-dialog-action-skip-and-confirm">
          {{ t('yard.drawers.createTaskDrawer.labels.skipAndConfirmMove') }}
        </v-btn>

        <v-btn
          variant="text"
          class="ml-auto"
          @click="closeDialog"
          data-testid="create-move-task-dialog-action-nevermind">
          {{ t('global.buttons.nevermind') }}
        </v-btn>
        <primary-button
          :disabled="isSubmitDisabled"
          @click="createTask"
          data-testid="create-move-task-dialog-action-save">
          {{ t('global.buttons.save') }}
        </primary-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">
:deep(.drawer-like) {
  width: 620px;
  max-width: 100%;
  position: fixed;
  right: 0;
  margin: 0;
  height: 100vh;
  max-height: 100%;

  .v-card {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
  }
}
</style>
